let localhostDev = false

let _host = localhostDev ? '/api' : 'http://dm.damaiiot.com'

let httpUrl = {
  'url': _host
}

export { httpUrl }



// WEBPACK FOOTER //
// ./src/api/index.js